module.exports = __webpack_public_path__ + "img/orbit-planet.9e36ac29.png";